export const QUNOMEDICAL_BRAND_ID = 'ZoYoIDxR4MkbKnMArUDam';
export const GOOGLE_ANALYTICS_ID = 'G-22555WY9GE';
